import LottieAnimation from 'react-lottie'

export default function Lottie({ animation, options = { loop: false }, ...props }){

    let animationData

    switch(animation){
        case 'support': animationData = require('assets/lotties/support.json'); break;
        case 'notification': animationData = require('assets/lotties/notification.json'); break;
        case 'remote': animationData = require('assets/lotties/remote.json'); break;
        case 'black-bnf': animationData = require('assets/lotties/black-bnf.json'); break;
        case 'cache': animationData = require('assets/lotties/cache.json'); break;
        case 'mail': animationData = require('assets/lotties/mail.json'); break;
    }

    return <LottieAnimation options={{ animationData, ...options }} {...props} />
}